module.exports = __webpack_public_path__ + "static/media/jiazai01.f51c3ed1.gif";